<template>

    <wrapper class="header-menu-row">
      <div class="header-row-top"><a class="header-mail" href="mailto:info@russoutdoor.ru">info@russoutdoor.ru</a><a  class="header-tel" href="tel:+74956265200">+7 (495) 626-52-00</a></div>
        <div class="header-row">
            <div class="logo-item">
                <link-to to="/" class="logo"><img src="/logo.png" alt="Russ Outdoor"></link-to>
            </div>

            <site-menu class="menu-desktop"  @currentMenu="currentMenu($event)"/>
            <div class="mobile-menu--trigger" :class="{ 'menu-open': isMenuOpen }" @click="toggleMenu(true)">Меню</div>
            <div class="mobile-menu" :class="{ open: isMenuOpen }">
                <site-menu/>
            </div>
            <search-form v-if="searchForm && false"></search-form>


            <div class="mobile-menu--overlay" v-if="isMenuOpen" @click="toggleMenu(false)"></div>
        </div>
    </wrapper>
</template>

<script>
    import SiteMenu from './Menu.vue'
    import SearchForm from './SearchForm.vue'

    export default {
        /*---Глобальный сео---*/

        data() {
            return {
                isMenuOpen: false,
                seoMenu: {
                    title: '',
                    description: '',
                    keywords: '',
                },
            };
        },
        props: {
            searchForm: { type: Boolean, default: true},
        },
        methods: {
            toggleMenu(open) {
                this.$store.state.menu.mobileMenuOpen = open;
                this.isMenuOpen = open;
            },
            currentMenu(event) {
                if(event) {
                    this.seoMenu.title = event ? event.title : ''
                    this.seoMenu.description = event ? event.description : ''
                    this.seoMenu.keywords = event ? event.keywords : ''
                }
            }
        },
        components: {
            SiteMenu,
            SearchForm
        }
    }
</script>

<style lang="scss">

    .header-menu-row {
        @media (max-width: $media_md) {
            // position: fixed;
            @include size(100%, 60px);
            @include linear-gradient(to right, $color-blue-2 0%, $color-blue-3 100%);
            z-index: 350;
        }
    }
    .header-row-top {
      display: flex;
      gap: 16px;
      flex-flow: row nowrap;
      justify-content: flex-end;
      align-items: center;
      @media (max-width: 990px) {
        padding-right: 10px;
      }
      .header-mail {
        width: 177px;
        height: 16px;
        padding-top: 48px;
        font-style: normal;
        text-decoration: none;
        font-weight: 400;
        font-size: 16px;
        line-height: 16px;
        display: flex;
        align-items: center;
        text-transform: uppercase;
        color: #FFFFFF;
        /* Inside auto layout */
        flex: none;
        order: 0;
        flex-grow: 0;

        @media (max-width: 1800px) {
          padding-top: 15px;
        }

      }
      .header-tel {
        /* +7 (495) 626-52-00 */
        width: 125px;
        height: 16px;
        padding-top: 48px;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        text-decoration: none;
        line-height: 16px;
        display: flex;
        align-items: center;
        text-transform: uppercase;
        color: #FFFFFF;
        flex: none;
        order: 1;
        flex-grow: 0;

        @media (max-width: 1800px) {
          padding-top: 15px;
        }
      }
    }
    .header-row {
        height: 80px;
        display: flex;display: -ms-flexbox;
        flex-flow: row nowrap;
        justify-content: space-between; -ms-flex-pack: justify;
        align-items: center;

        @media (max-width: 1100px) {
            height: 60px;
        }
        .logo-item {
            margin-right: 5%;
            img {
                height: 35px;
            }
        }
        .menu-desktop {
            display: flex;display: -ms-flexbox;
            flex-flow: row nowrap; // ! enable wrap
            align-items: center;
            justify-content: space-evenly;
            flex: auto;
            width: 85%;

            @media (max-width: 990px) {
                display: none;
            }
            .menu-item {
                padding: 0 5px;
                margin: 5px auto;
                @media (max-width: 1100px) {
                    padding: 0 10px;
                }
                a {
                    display: block;
                    white-space: nowrap;
                    padding: 5px 0;
                    color: $color-white;
                    text-decoration: none;
                    text-transform: uppercase;
                    position: relative;
                    line-height: 12px;
                    border-bottom: 1px solid transparent;
                    @include ease();
                    &:hover,&.nuxt-link-active {
                        border-bottom: 1px solid;
                    }
                    @media (min-width: 991px) and (max-width: 1279px) {
                        font-size: 12px;
                    }


                }
                &--right {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    align-self: right;
                    position: relative;
                    z-index: 5;
                    @media (max-width: 990px) {
                        width: 100%;
                    }


                }
                &--button {
                    display: block;
                    position: relative;
                    z-index: 6;
                    cursor: pointer;
                    background-color: rgba(255,255,255,0.2);
                    border-radius: 5px;
                    border: 1px solid #fff;
                    color: #fff;
                    text-transform: uppercase;
                    text-decoration: none;
                    padding-left: 10px;
                    padding-right: 10px;
                    padding-top: 9px;
                    padding-bottom: 9px;
                    margin-right: 10px;
                    margin-left: 0 !important;
                    font-size: 16px;
                    &:hover {
                        color: #0054a2;
                        background-color: #fafbfc;
                    }

                    @media (max-width: 990px) {
                        border: 1px solid #0054a2;
                    }
                    @media (max-width: 990px) {
                        border: none;
                        background-color: none;
                        padding-left: 0;
                        padding-right: 0;
                        color: #0054a2;
                        padding-top: 22px;
                        padding-bottom: 22px;


                    }
                    margin-left: 10px;
                    @media (min-width: 991px) and (max-width: 1279px) {
                        font-size: 12px;
                    }
                }
                &--list {
                    &.hidden {
                        display: none;
                    }
                    position: absolute;
                    top: 32px;
                    z-index: 999 !important;
                    left: 0;
                    width: 360px;
                    @media (max-width: 990px) {
                        width: 100%;
                    }

                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    background: #FAFBFC;
                    box-shadow: 0px 4px 32px rgba(0, 52, 95, 0.25);
                    border-radius: 10px;
                    border-top-left-radius: 0;
                    padding-top: 23px;
                    padding-left: 39px;
                    padding-right: 15px;
                    padding-bottom: 10px;

                    & li {
                        display: flex;
                        flex-direction: column;
                    }
                    & a {
                        position: relative;
                        padding-left: 33px;
                        text-decoration: none;
                        color: #0054A2;
                        font-size: 18px;
                        font-weight: bold;
                        margin-bottom: 8px;
                        &::before {
                            content: '';
                            display: block;
                            width: 24px;
                            height: 24px;
                            background: url("/images/icons/arrow-right.png") no-repeat;
                            background-size: cover;
                            position: absolute;
                            top: -4px;
                            left: 0;
                        }
                    }
                    & span {
                        font-weight: 400;
                        font-size: 16px;
                        line-height: 24px;
                        padding-left: 33px;
                        color: #212529;
                        margin-bottom: 24px;
                    }

                }
                &--text {
                    font-size: 13px;
                    max-width: 170px;
                    color: #fff;
                    text-transform: none;
                    @media (min-width: 991px) and (max-width: 1279px) {
                        font-size: 12px;
                        max-width: 160px;
                    }
                    @media (max-width: 990px) {
                        color: #fff;
                        max-width: 100%;
                    }
                }
            }

        }

        .mobile-menu--trigger {
            display: none;
            @include size(30px);
            @include background-contain('/images/ui/menu.svg');
            @include ease();
            font-size: 0;
            margin-right: 10px;
            @media (max-width: 990px) {
                display: block;
            }
            &.menu-open {
                transform: rotate(90deg);
                opacity: 0;
            }
        }
        .mobile-menu {
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            @include size(320px, 150vh);
            @include ease();
            padding: 50px 70px;
            box-sizing: border-box;
            background: $color-white;
            z-index: 9999;
            @media (max-width: 990px) {
                display: block;
                transform: translateX(-100%);
                opacity: 1;
            }
            @media (max-width: 400px) {
                padding: 15px 35px;
                width: 240px;
            }
            &.open {
                transform: none;
                opacity: 1;
            }
            .menu-item {
                padding: 10px 0;
                a {
                    display: inline-block;
                    color: $color-link;
                    text-decoration: none;
                    text-transform: uppercase;
                    padding: 5px 0;
                    &.path-exact,
                    &.path-exist {
                        border-bottom: 2px solid $color-link;
                    }
                }
                &--right {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                }
                &--button {
                    border: none;
                    background-color: none;
                    padding-left: 0;
                    padding-right: 0;
                    color: #0054a2;
                    padding-top: 22px;
                    padding-bottom: 22px;
                    font-size: 16px;
                    text-transform: uppercase;
                }

                &--text {
                    color: #0885be;
                    margin-bottom: 15px;
                    max-width: auto;
                }
                &--list {
                    &.hidden {
                        display: none;
                    }
                    position: relative;
                    top: auto;
                    left: -85px;
                    @media (max-width: 990px) {
                        width: 320px;
                    }
                    @media (max-width: 400px) {
                        width: 240px;
                        left: -62px;
                    }
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    background: #fff;
                    box-shadow: none;
                    border-radius: 0;
                    padding-top: 23px;
                    padding-left: 39px;
                    padding-right: 15px;
                    padding-bottom: 10px;
                    & li {
                        display: flex;
                        flex-direction: column;
                    }
                    & a {
                        position: relative;
                        padding-left: 33px;
                        text-decoration: none;
                        color: #0054A2;
                        font-size: 18px;
                        font-weight: bold;
                        margin-bottom: 8px;
                        &::before {
                            content: '';
                            display: block;
                            width: 24px;
                            height: 24px;
                            background: url("/images/icons/arrow-right.png") no-repeat;
                            background-size: cover;
                            position: absolute;
                            top: -4px;
                            left: 0;
                        }
                    }
                    & span {
                        font-weight: 400;
                        font-size: 13px;
                        line-height: 24px;
                        padding-left: 33px;
                        color: #212529;
                        margin-bottom: 24px;
                    }

                }
                &--text {
                    display: none;
                    /*font-size: 13px;
                    max-width: 170px;
                color: #0054a2;
                text-transform: none;
                @media (min-width: 991px) and (max-width: 1279px) {
                    font-size: 12px;
          max-width: 160px;
                }
                @media (max-width: 990px) {
                color: #0054a2;
                max-width: 100%;
                }*/
                }
            }
        }

        .mobile-menu--overlay {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 300;
            @include size(100vw, 150vh);
            background: fade-out($color-black, 0.3) url('/images/ui/menu-close.svg') no-repeat;
            background-position: right 25px top 18px;
            background-size: 25px;

            @media (min-width: 990px) {
                display: none;
            }
        }
    }
    .header-index.header-fix {
      @media (max-width: 990px) {
        height: 70px;
      }

        .menu-item--button {
            color: #fff;
            background-color: transparent;
        }
        .menu-item--text {
            color: #fff;
        }
        @media (max-width: 990px) {
            .menu-item--button {
                color: #0885be;
            }
            .menu-item--text {
                color: #0885be;
            }
        }
    }
    .header-index.header-abs  {
        position: absolute !important;
    }
    .header .header-inner .menu-item--text,
    .header-bg .header-index .menu-item--text {
        @media (min-width: 991px) {
            color: #fff;
        }
    }

    // Disable hover for touch devices
    body.touch {
        .header-row .menu-desktop .menu-item a:hover {
            color: $color-white !important;
            &:after {
                background-color: $color-white !important;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// components/header/HeaderMenu.vue